import { ApiList, ApiResponse } from "../../../../types/api.types";
import axiosClient from "../../../../utils/axios";
import {
  ActivityLog,
  ActivityLogListRequest,
} from "../types/activityLog.types";

export const getActivityLogList = async (
  payload: ActivityLogListRequest,
): Promise<ApiResponse<ApiList<ActivityLog>>> => {
  try {
    const response = await axiosClient.post<ApiResponse<ApiList<ActivityLog>>>(
      "/user-audit-logs",
      payload,
    );
    return response.data;
  } catch (err) {
    console.warn("Error fetching activity log list: ", err);
    throw err;
  }
};
